import MapboxDraw from '@mapbox/mapbox-gl-draw';
import _ from 'lodash';

const ExtendedDrawLineString = _.extend({}, MapboxDraw.modes.draw_line_string);

ExtendedDrawLineString.onStop = function (state) {
    if (this.getFeature(state.line.id) === undefined) {
        this.map.fire('draw.cancelled');
    }
    MapboxDraw.modes.draw_line_string.onStop.call(this, state);
};

ExtendedDrawLineString.toDisplayFeatures = function (state, geojson, display) {
    MapboxDraw.modes.draw_line_string.toDisplayFeatures.call(this, state, geojson, display);
    if (geojson.properties.id === state.line.id && geojson.geometry.coordinates.length > 1) {
        this.map.fire('draw.editing', {
            features: [geojson]
        });
    }
};

export default ExtendedDrawLineString;
